import yup from "../utility/ValidationUtilty";

export type ReplyButton = {
  id: string;
  tenantId?: string;
  messageId?: string;
  name: string;
  buttonNumber: number;
  buttonName: string[];
  buttonColor: string[];
  type: string;
  createUser: string;
  createAt: Date;
  sendDate?: Date;
  eventAt?: Date;
}

export type ButtonSettingItems = {
  buttonName1: string;
  buttonName2?: string;
  buttonName3?: string;
}

export const newReplyButton: ReplyButton = {
  id: '',
  name: '',
  buttonNumber: 3,
  buttonName: [],
  buttonColor: [],
  type: '',
  createUser: '',
  createAt: new Date()
}

export const replyButtonSchema = yup.object({
  name: yup.string().required(),
  buttonName1: yup.string().required(),
  buttonName2: yup.string().when('buttonNumber', {
    is: (buttonNumber: number) => buttonNumber >= 2,
    then: yup.string().required()
  }),
  buttonName3: yup.string().when('buttonNumber', {
    is: (buttonNumber: number) => buttonNumber >= 3,
    then: yup.string().required()
  })
});